import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingRoomEditDefault_EditPage_Query = graphql(`
	query ExistingRoomEditDefault_EditPage($hotelID: ID!, $roomId: ID!) {
		room(hotelID: $hotelID, roomID: $roomId) {
			id
			hotelID
			roomID
			inSale
			isNotDiscountTarget
			isDormitoryType
			isShowStockPreview
			maxRoomNum
			availablePlanIDs
			capacityPeopleMaximum
			capacityAdultMaximum
			capacityKidsMaximum
			isKidsUnavailable
			kidsPolicy {
				kidsMaxAge
				kidsDiscountType
				ratio
				static {
					currencyType
					amount
				}
			}
			name
			catchCopy
			description
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			keyVisuals {
				bucket
				key
				region
				mimeType
				fileName
			}
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			articleTitle
			saleTypeForPlan
			requiredPrepMillisecond
			amenities
			beds {
				bedType
				bedNum
			}
			roomSize
			overSiteControllerPeopleNum {
				prices {
					upperNum
					price {
						currencyType
						amount
					}
				}
				availableWeekDays
			}
			isExtendSiteControllerPeopleNum
			address {
				nationality
				postalCode
				state
				pref
				city
				town
				other
			}
			geoLocation {
				lat
				lon
			}
		}
		hotelPolicy(hotelID: $hotelID) {
			amenities
		}
		hotelPolicy(hotelID: $hotelID) {
			requiredPrepMillisecond
		}
		planList(hotelID: $hotelID) {
			id
			hotelID
			plans {
				planID
				name
				id
			}
			secrets {
				planID
				name
				id
			}
		}
		discountList(hotelID: $hotelID) {
			id
			ordinary {
				discountID
				id
				name
				hotelID
				isRoomDiscountEligible
			}
		}
	}
`);
